// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".next-fixture-section{border-radius:5%;border:2px solid #28a745;margin-bottom:5px}@media only screen and (max-width: 400px)and (max-height: 750px),screen and (max-width: 780px)and (max-height: 400px){.section-header{font-weight:bold}.next-fixture-text{font-size:large}}", ""]);
// Exports
module.exports = exports;
